/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { OrderLib, OrderLibInterface } from "../OrderLib";

const _abi = [
  {
    inputs: [],
    name: "COMMON_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SALT",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ZERO_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x61034c61003a600b82828239805160001a60731461002d57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100775760003560e01c80633644e5151461007c578063538ba4f9146100975780637c9f1a67146100b7578063ba9a91a5146100de578063c7977be7146100f3578063e1b11da4146100fb578063f973a20914610110575b600080fd5b610084610137565b6040519081526020015b60405180910390f35b61009f600081565b6040516001600160a01b03909116815260200161008e565b6100847f71bfa0947df3be80152ba97f3d959fef24fbd7294464941f321d3b74f575f09081565b6100846000805160206102f783398151915281565b6100846101ff565b610103610222565b60405161008e919061023e565b6100847ff4a51a688613d203ff9718f2ff2ea952f12b8d6a1e9872af1ca3127491e71dae81565b6040518060a001604052806063815260200161029460639139805160209182012060408051928301919091527f2bd0f6de01d729f9b7b958762e9a8dc532db80e4397d4a227c0624582d84f877908201527fc89efdaa54c0f20c7adf612882df0950f5a951637e0307cdcb4c672f298b8bc6606082015260016080820152736e80c53f2cdcad7843ad765e4918298427aac55060a08201526000805160206102f783398151915260c082015260e0016040516020818303038152906040528051906020012081565b6040518060a0016040528060638152602001610294606391398051906020012081565b6040518060a00160405280606381526020016102946063913981565b600060208083528351808285015260005b8181101561026b5785810183015185820160400152820161024f565b8181111561027d576000604083870101525b50601f01601f191692909201604001939250505056fe454950373132446f6d61696e28737472696e67206e616d652c20737472696e672076657273696f6e2c2075696e7432353620636861696e49642c206164647265737320766572696679696e67436f6e74726163742c20627974657333322073616c7429d88895693d3e790da21d74ec7593f2553c13e1fc9e8dacf6e6a2a82689edcffaa26469706673582212208b8f79d7848eef897683212864727add01d2eae07dc56912b0d05d021797fcc764736f6c63430008090033";

type OrderLibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OrderLibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OrderLib__factory extends ContractFactory {
  constructor(...args: OrderLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<OrderLib> {
    return super.deploy(overrides || {}) as Promise<OrderLib>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OrderLib {
    return super.attach(address) as OrderLib;
  }
  connect(signer: Signer): OrderLib__factory {
    return super.connect(signer) as OrderLib__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OrderLibInterface {
    return new utils.Interface(_abi) as OrderLibInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrderLib {
    return new Contract(address, _abi, signerOrProvider) as OrderLib;
  }
}
